import React, { Component } from "react";
import { Modal, Spin, Input, Form, Alert, message } from "antd";
import { DownloadOutlined, PrinterOutlined, ReloadOutlined, EyeOutlined, UndoOutlined } from "@ant-design/icons";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ButtonItem } from "../../../../Components/Items";
import reporteVisitaCMMSPdf, { textosReporteVisita } from "../../../../Pdf/cmms/reporteVisitaCMMSPdf";
import { medirMarcaAgua } from "../../../../Pdf/cmms/comunCMMSPdf";
import { cmmsPost } from "../cmmsComun";
import { mostrarPdfEnIframe } from "./ModalPdfCMMS";
import "../cmms.css";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { TextArea } = Input;

// Reporte de visita tecnica: la carta se arma sola con lo atendido en la visita (mismo cliente,
// sucursal y dia) y aqui se pueden corregir sus textos antes de descargarla. El Anexo A sale
// de las Ordenes de Servicio.
const CAMPOS = [
    { clave: "asunto", etiqueta: "Asunto" },
    { clave: "lugarFecha", etiqueta: "Lugar y fecha", ayuda: "El lugar se configura en Configuración > Impresión." },
    { clave: "destinatario", etiqueta: "Destinatario", filas: 2 },
    { clave: "saludo", etiqueta: "Saludo" },
    { clave: "objetivo", etiqueta: "Objetivo de la visita", filas: 3 },
    { clave: "resumen", etiqueta: "Resumen", filas: 3 },
    { clave: "detalleRealizados", etiqueta: "Servicios realizados", filas: 5 },
    { clave: "detalleReportes", etiqueta: "Reportes atendidos", filas: 4 },
    { clave: "cierre", etiqueta: "Cierre", filas: 2 },
    { clave: "despedida", etiqueta: "Despedida" },
    { clave: "firmante", etiqueta: "Firma" },
    { clave: "puesto", etiqueta: "Puesto o empresa de quien firma" },
    { clave: "tituloAnexo", etiqueta: "Título del Anexo A" },
    { clave: "departamento", etiqueta: "Departamento" },
];

const guardarFirmante = (textos) => {
    try {
        window.localStorage.setItem("cmms.reporteVisita.firmante", JSON.stringify({ nombre: textos.firmante || "", puesto: textos.puesto || "" }));
    } catch (e) {
        // sin almacenamiento local no se recuerda quien firma
    }
};

class ModalReporteVisitaCMMS extends Component {
    state = { cargando: false, datos: null, textos: null, pdf: null, pendiente: false };
    iframeRef = React.createRef();
    urlPdf = null;

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) this.cargar();
        if (!this.props.visible && prevProps.visible) this.setState({ datos: null, textos: null, pdf: null, pendiente: false });
    }

    componentWillUnmount() {
        if (this.urlPdf) URL.revokeObjectURL(this.urlPdf);
    }

    cargar = async () => {
        this.setState({ cargando: true });
        try {
            const res = await cmmsPost(this.props, "datosReporteVisitaPdfCMMS", { servicioId: this.props.servicioId });
            if (res.data.success !== 2) {
                message.error(res.data.message || "No se pudieron consultar los datos de la visita");
                return this.props.onClose();
            }
            const datos = await medirMarcaAgua(res.data.datos);
            this.setState({ datos, textos: textosReporteVisita(datos) }, this.vistaPrevia);
        } catch (error) {
            console.log(error);
            message.error("No se pudieron consultar los datos de la visita");
        } finally {
            this.setState({ cargando: false });
        }
    };

    armarPdf = () => pdfMake.createPdf(reporteVisitaCMMSPdf(this.state.datos, this.state.textos));

    vistaPrevia = async () => {
        if (!this.state.datos) return;
        try {
            const pdf = this.armarPdf();
            this.setState({ pdf, pendiente: false });
            this.urlPdf = await mostrarPdfEnIframe(pdf, this.iframeRef.current, this.urlPdf);
        } catch (error) {
            console.log(error);
            message.error("No se pudo generar el PDF");
        }
    };

    // Descargar / imprimir siempre con los textos actuales (aunque no se haya actualizado la vista).
    conPdfActual = (accion) => {
        if (!this.state.datos) return;
        guardarFirmante(this.state.textos);
        const pdf = this.state.pendiente || !this.state.pdf ? this.armarPdf() : this.state.pdf;
        if (accion === "descargar") pdf.download(`ReporteVisita_${this.props.codigo || ""}.pdf`);
        else pdf.print();
    };

    cambiar = (clave, valor) => this.setState({ textos: { ...this.state.textos, [clave]: valor }, pendiente: true });

    restablecer = () =>
        Modal.confirm({
            title: "¿Restablecer los textos?",
            content: "Se pierden los cambios hechos a la carta y se vuelve a armar con lo atendido en la visita.",
            okText: "Restablecer",
            cancelText: "Regresar",
            onOk: () => this.setState({ textos: textosReporteVisita(this.state.datos) }, this.vistaPrevia),
        });

    renderTextos() {
        const t = this.state.textos;
        if (!t) return null;
        return (
            <Form layout="vertical" className="cmms-carta-editor">
                {CAMPOS.map((c) => (
                    <Form.Item key={c.clave} label={c.etiqueta} extra={c.ayuda}>
                        {c.filas ? (
                            <TextArea value={t[c.clave]} autoSize={{ minRows: c.filas, maxRows: 14 }} onChange={(e) => this.cambiar(c.clave, e.target.value)} />
                        ) : (
                            <Input value={t[c.clave]} onChange={(e) => this.cambiar(c.clave, e.target.value)} />
                        )}
                    </Form.Item>
                ))}
            </Form>
        );
    }

    render() {
        const d = this.state.datos;
        const listo = !!d;
        return (
            <Modal
                className="cmms-modal"
                visible={this.props.visible}
                onCancel={this.props.onClose}
                width={window.innerWidth > 1200 ? 1180 : "96%"}
                centered
                title={<div className="cmms-modal-titulo-texto">Reporte de visita técnica</div>}
                footer={
                    <div style={{ display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap" }}>
                        <ButtonItem blanco lessTime icon={<UndoOutlined />} disabled={!listo} onClick={this.restablecer}>
                            Restablecer textos
                        </ButtonItem>
                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                            <ButtonItem blanco onClick={this.props.onClose}>
                                Cerrar
                            </ButtonItem>
                            <ButtonItem blanco icon={<PrinterOutlined />} disabled={!listo} onClick={() => this.conPdfActual("imprimir")}>
                                Imprimir
                            </ButtonItem>
                            <ButtonItem cyan icon={<DownloadOutlined />} disabled={!listo} onClick={() => this.conPdfActual("descargar")}>
                                Descargar
                            </ButtonItem>
                        </div>
                    </div>
                }
            >
                <Spin spinning={this.state.cargando} tip="Armando el reporte...">
                    <div className="cmms-visita-cuerpo">
                        {d && (
                            <div className="cmms-ayuda">
                                Visita del {d.fecha ? d.fecha.split("-").reverse().join("/") : ""} · {d.cliente?.nombre || "Sin cliente"}
                                {d.cliente?.sucursal ? ` · ${d.cliente.sucursal}` : ""} · {d.total} {d.total === 1 ? "orden" : "órdenes"} de servicio. La carta se arma sola; corrija lo que necesite y
                                actualice la vista previa.
                            </div>
                        )}
                        <div className="cmms-visita-columnas">
                            <div className="cmms-visita-textos">{this.renderTextos()}</div>
                            <div className="cmms-visita-vista">
                                {this.state.pendiente && (
                                    <Alert
                                        type="info"
                                        showIcon
                                        icon={<EyeOutlined />}
                                        message="Cambió textos de la carta"
                                        action={
                                            <ButtonItem cyan size="small" lessTime icon={<ReloadOutlined />} onClick={this.vistaPrevia}>
                                                Actualizar vista previa
                                            </ButtonItem>
                                        }
                                    />
                                )}
                                <iframe ref={this.iframeRef} title="Reporte de visita" />
                            </div>
                        </div>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default ModalReporteVisitaCMMS;
